import { CircularProgress, Grid2, Typography } from '@mui/material';
import styles from './CircularProgress.module.css';

const CircularProgressWithLabel = ({ currentValue, maxValue, label, unit }: { currentValue: number, maxValue: number, label: string, unit: string }) => {
    const progress = Math.min((currentValue / maxValue) * 100, 100);
    return (
        <Grid2 className={styles.progress_container_wrapper}>
            <Grid2 className={styles.progress_container}>
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={60}
                    thickness={4}
                    className={styles.background_progress}
                />
                <CircularProgress
                    variant="determinate"
                    value={progress}
                    size={60}
                    thickness={4}
                    className={styles.foreground_progress}
                    sx={{
                        color: currentValue <= maxValue ? '#8CD867' : '#D22B2B',
                    }}
                />
                <Typography className={styles.progress_value} variant="caption4LightOutfit" color="textPrimary">
                    {`${Math.round(currentValue)}`}
                </Typography>
            </Grid2>
            <Grid2  className={styles.progress_text_container}>
                <Grid2 className={styles.unit}>
                    <Typography variant="ingredientText2paralellOutfit">{`/ ${maxValue} ${unit}`}</Typography>
                </Grid2>
                <Grid2 className={styles.label}>
                    <Typography variant="caption4LightOutfit">{label}</Typography>
                </Grid2>
            </Grid2>
        </Grid2>
    );
}

export default CircularProgressWithLabel;
